import React from 'react'

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import AppHeader from 'containers/core/AppHeader'

import ScreenSizeMessage from 'components/atoms/ScreenSizeMessage'

import * as userActions from 'actions/userActions'

const styles = theme => ({
  root: {},
  content: {
    marginTop: theme.spacing(6),
  },
})

const Dashboard = ({
  classes, children, refresh, location: locationProp
}) => {
  const { props: propsChildren } = children

  return (
    <section className={classes.root}>
      <AppHeader
        location={locationProp.pathname}
        headerLinks={propsChildren.children}
      />
      {!refresh && children}
      <ScreenSizeMessage />
    </section>
  )
}

Dashboard.propTypes = {
  size: PropTypes.object,
  refresh: PropTypes.bool,
  children: PropTypes.node,
  classes: PropTypes.object,
  actions: PropTypes.object,
  location: PropTypes.object,
}

function mapStateToProps(state) {
  return state
}

function mapDispatchToProps(dispatch) {
  const actions = Object.assign({}, userActions)
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

const DashboardComponent = withStyles(styles)(Dashboard)

export default connect(mapStateToProps, mapDispatchToProps)(DashboardComponent)



// WEBPACK FOOTER //
// ./src/containers/core/Dashboard/Dashboard.js